<template>
  <LabelledInput
    label="Border width"
    helpful-tip="Width of the border for the hollow and selected bubbles. Note: a large border width will make small bubbles appear solid and may override the minimum bubble size parameter."
  >
    <b-input-group>
      <b-input
        v-model="width"
        type="number"
        :min="min"
        :step="step"
        style="max-width: 5em;"
      />
      <b-input
        v-model="width"
        type="range"
        :min="min"
        :max="max"
        :step="step"
        class="px-0"
      />
    </b-input-group>
  </LabelledInput>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { HOLLOW_BUBBLES_CONFIG_KEY } from '@/constants'

const components = {
  LabelledInput,
}

@Component({ components })
export default class BorderWidth extends Vue {
  min = 1
  max = 50
  step = 1

  get width () {
    return this.$typedStore.primary.app.config[HOLLOW_BUBBLES_CONFIG_KEY].borderWidth
  }

  set width (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [HOLLOW_BUBBLES_CONFIG_KEY, 'borderWidth'],
      value: newValue,
    })
  }
}

</script>
